import { connect } from 'react-redux';
import { withRouter } from "react-router";
import Home from '../../components/Tab';

const mapState = ({auth: { user }}) => {
    return {
        user: user,
    };
};

export default connect(
mapState,
{},
)(withRouter(Home));